import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/SectionLabel";

const FORUMS = [
    {
        index: "I",
        title: "Model United Nations",
        lines: ["Step into global issues.", "Represent nations.", "Drive change."],
        cta: "Explore MUN",
        to: "/committees#mun",
        testId: "forum-explore-mun",
    },
    {
        index: "II",
        title: "Youth Parliament",
        lines: ["Debate policies.", "Challenge ideas.", "Shape the future."],
        cta: "Explore Youth Parliament",
        to: "/committees#youth",
        testId: "forum-explore-youth",
    },
];

const Forums = () => (
    <section id="forums" data-testid="forums-section" className="scroll-mt-24 bg-coal/50 py-24 md:py-36">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
            <Reveal>
                <SectionLabel index="03" text="The Forums" />
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-8 max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
                    Diverse Forums.
                    <br />
                    Limitless <em className="italic text-scarlet">Perspectives.</em>
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-6 lg:grid-cols-2 lg:gap-8">
                {FORUMS.map((forum, i) => (
                    <Reveal key={forum.title} delay={0.15 + i * 0.1}>
                        <div className="group relative flex min-h-[380px] flex-col justify-between overflow-hidden border border-cream/5 bg-ink p-8 transition-colors duration-500 hover:border-crimson/60 md:min-h-[440px] md:p-12">
                            <div
                                aria-hidden="true"
                                className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_80%_-10%,rgba(201,31,38,0.14),transparent_60%)] opacity-0 transition-opacity duration-700 group-hover:opacity-100"
                            />
                            <div className="relative">
                                <span className="font-serif text-2xl italic text-scarlet/80">
                                    {forum.index}.
                                </span>
                                <h3 className="mt-6 font-serif text-3xl font-light leading-tight tracking-tight text-cream md:text-5xl">
                                    {forum.title}
                                </h3>
                                <ul className="mt-8 space-y-2">
                                    {forum.lines.map((line) => (
                                        <li
                                            key={line}
                                            className="text-base font-light text-ash md:text-lg"
                                        >
                                            {line}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <Link
                                to={forum.to}
                                data-testid={forum.testId}
                                className="group/link relative mt-10 inline-flex w-fit items-center gap-3 font-sans text-[11px] font-semibold uppercase tracking-[0.3em] text-cream transition-colors duration-300 hover:text-scarlet"
                            >
                                {forum.cta}
                                <ArrowRight className="h-4 w-4 text-scarlet transition-transform duration-300 group-hover/link:translate-x-1.5" />
                                <span className="absolute -bottom-2 left-0 h-px w-full origin-left scale-x-0 bg-scarlet transition-transform duration-300 group-hover/link:scale-x-100" />
                            </Link>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Forums;
